import { render, staticRenderFns } from "./DeviceTestFetch.vue?vue&type=template&id=524c5bd7&scoped=true&"
import script from "./DeviceTestFetch.vue?vue&type=script&lang=js&"
export * from "./DeviceTestFetch.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTestFetch.vue?vue&type=style&index=0&id=524c5bd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c5bd7",
  null
  
)

export default component.exports